import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import AdminEventScheduleItem from "./AdminEventScheduleItem";
import AdminDndList from "~/Admin/AdminDndList/AdminDndList";
import {loadEventsAction} from "~/Admin/redux/actions/event";
import {groupBy} from "~/services/helpers";
import Moment from "react-moment";
import monent from "moment";
import AdminTextEdit from "~/Admin/AdminText/AdminTextEdit";
import ToggleSwitch from '../../../Components/ToggleSwitch/ToggleSwitch';
import { updateEvent } from '../../redux/actions/event';

const AdminEventSchedule = ({match, event, ...props}) => {
    const [selectedId, setSelectedId] = useState(event.schedules[0]?.id || 0);
    const [showSchedule, setShowSchedule] = useState(event?.schedule_status || false);

    const handleOrderChanged = (data) => {
        adminHttp.put('/events/' + event.id + '/schedules/order', {
            data: data.map(i => i.id)
        });
    }

    const handleAdd = () => {

        let body = {};

        if (selectedSch?.date) {
            body.date = selectedSch?.date;
        }

        adminHttp.post(`/events/${event.id}/schedules`, body).then(res => {
            updated();
        });
    }

    const updated = () => {
        props.dispatch(loadEventsAction());
    };

    const handleSchedulesDisplay = () => {
        adminHttp.put(`events/${event.id}/schedule-status`)
            .then(res => {
                setShowSchedule(res.data.schedule_status);
                props.dispatch(updateEvent(res.data));
            })
    }

    const selectedSch = event.schedules.find(item => item.id === selectedId);

    const grouped = groupBy(event.schedules, 'date');

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-8">
                            <h3>Event Schedule</h3>
                        </div>
                        <div className="col-4 text-right">
                            <AdminTextEdit name={'schedule-head-title'}
                                           onChange={updated}
                                           className="text-primary cursor-pointer">
                                Edit Paragraph
                            </AdminTextEdit>
                        </div>

                        <div className="toggle-schedules col-12">
                            <p className="text-subhead m-0">Show/Hide schedule</p>
                            <p className="text-caption-1 font-weight-normal m-0">Enable the toggle to display the event schedule on the user portal.</p>
                            <ToggleSwitch
                                id="schedule_check"
                                label2="Hide schedule"
                                isChecked={showSchedule}
                                onChange={handleSchedulesDisplay}
                            />
                        </div>

                        {showSchedule && <>
                        <div className="col-4">
                            {Object.keys(grouped).map(dateValue => (
                                <div className="mb-3" key={dateValue}>
                                    <div className="text-uppercase font-weight-500">
                                        <Moment format="DD/MM/YYYY" date={dateValue} />

                                        <AdminTextEdit name={'schedule-' + monent(dateValue).format('DD/MM/YYYY')}
                                                       onChange={updated}
                                                       className="small ml-1 text-primary cursor-pointer">
                                            Edit Paragraph
                                        </AdminTextEdit>
                                    </div>

                                    <AdminDndList
                                        key={event.updated_at}
                                        onChanged={handleOrderChanged}
                                        onSelect={setSelectedId}
                                        selected={selectedId}
                                        list={grouped[dateValue]} />
                                </div>
                            ))}

                            <button
                                onClick={handleAdd}
                                className="btn btn-primary btn-sm w-100">
                                + Add Schedule
                                {selectedSch && <span className="ml-1">
                                    (<Moment format="DD/MM/YYYY" date={selectedSch.date} />)
                                </span>}
                            </button>

                        </div>
                        <div className="col-8">
                            {selectedSch && <AdminEventScheduleItem
                                key={selectedId}
                                onChange={updated}
                                onDelete={updated}
                                schedule={selectedSch} />}
                        </div>
                        </>}
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventSchedule);
